import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Running Course & Batch")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_18 = { class: "col-md-2 mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Running Batch List")
  ])
], -1)
const _hoisted_21 = { class: "row w-100 mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_23 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "card mb-5 mb-xl-10" }
const _hoisted_31 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_32 = { class: "row mt-1 w-100 m-0" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "div pb-2" }
const _hoisted_35 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_43 = { class: "collapse show" }
const _hoisted_44 = { class: "card-body border-top p-6" }
const _hoisted_45 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_46 = ["href"]
const _hoisted_47 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_BatchDrawer = _resolveComponent("BatchDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    name: "tranche_id",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: tranche.id,
                          label: tranche.label,
                          value: tranche.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tranche.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Training Partner",
                    name: "entity_id",
                    modelValue: _ctx.batch.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.getTrainingInstitute
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: 
                    '[' + info.entity_short_name + '] - ' + info.entity_name
                  ,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.batch.institute_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                    name: "institute_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.courseInfo
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.institute_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Course",
                    modelValue: _ctx.batch.course_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                    name: "course_id",
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.course_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchDetails())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_19
                  ])
                ])
              ]),
              (_ctx.showDetails == true)
                ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                          title: "Download Xlse",
                          "data-v-54b12dc8": "",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportTrainee()))
                        }, _hoisted_25),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Download PDF",
                          "data-v-54b12dc8": "",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadPdf()))
                        }, _hoisted_27),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Print",
                          "data-v-54b12dc8": "",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.printPdf()))
                        }, _hoisted_29)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control ps-10 w-200px mt-1 form-control-sm",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.search) = $event)),
                                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchItems())),
                                style: {"height":"1em"},
                                placeholder: "Search"
                              }, null, 544), [
                                [_vModelText, _ctx.search]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                              title: "Download Xlse",
                              "data-v-54b12dc8": "",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.exportTrainee()))
                            }, _hoisted_37),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Download PDF",
                              "data-v-54b12dc8": "",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.downloadPdf()))
                            }, _hoisted_39),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                              title: "Print",
                              "data-v-54b12dc8": "",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.printPdf()))
                            }, _hoisted_41)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_Datatable, {
                                "table-data": _ctx.tableData,
                                "table-header": _ctx.tableHeader,
                                "enable-items-per-page-dropdown": true
                              }, {
                                "cell-sl": _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(row.id), 1)
                                ]),
                                "cell-tranche": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.tranche_info), 1)
                                ]),
                                "cell-entity_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.entity_name), 1)
                                ]),
                                "cell-ins_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.institute_name), 1)
                                ]),
                                "cell-division": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.division_name), 1)
                                ]),
                                "cell-district_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.district_name), 1)
                                ]),
                                "cell-present_address": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.present_address), 1)
                                ]),
                                "cell-course_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.course_name), 1)
                                ]),
                                "cell-month": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.month), 1)
                                ]),
                                "cell-hour": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.hour), 1)
                                ]),
                                "cell-batch_number": _withCtx(({ row: industry }) => [
                                  _createElementVNode("a", {
                                    href: 
                              `${this.VUE_APP_TMS}/course-batch/view/` +
                              industry?.id
                            ,
                                    "data-search-type": "batch",
                                    "data-search-key": "2005",
                                    title: "Batch View",
                                    target: "_blank"
                                  }, _toDisplayString(industry?.batch_number), 9, _hoisted_46)
                                ]),
                                "cell-trainee_count": _withCtx(({ row: industry }) => [
                                  _createElementVNode("a", {
                                    href: `${this.VUE_APP_TMS}/batch-trainee-summary/` +
                                   industry?.id +
                                    '/' +
                                    1 +
                                    '/' +
                                    1
                                    ,
                                    target: "_blank",
                                    class: "text-primary"
                                  }, _toDisplayString(industry?.trainee_count), 9, _hoisted_47)
                                ]),
                                "cell-start_date": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.start_date ? _ctx.moment(industry.start_date).format('DD-MM-YYYY'):''), 1)
                                ]),
                                "cell-end_date": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.end_date ?_ctx.moment(industry.end_date).format('DD-MM-YYYY') : ''), 1)
                                ]),
                                _: 1
                              }, 8, ["table-data", "table-header"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_BatchDrawer)
  ], 64))
}